import { isWyak, isWeParty,isLamaLudo, isInChat} from "@mono/utils";

export const getCurrencySymbol = (locale, currency) => {
  const formattedLocale = locale.replace('_', '-');
  var symbol = (0)
    .toLocaleString(formattedLocale, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, "")
    .trim();
  return symbol;
};

export const get28CoinIcon = () => {
  if (isWyak) {
    return require("@mono/ui/assets/common_coin_28_ic_wyak.png");
  } else if (isWeParty) {
    return require("@mono/ui/assets/common_coin_28_ic_weparty.png");
  } else if (isLamaLudo){
    return require("@mono/ui/assets/common_blue_diamond_32_ic_ludo.png");
  } else if (isInChat){
    return require("@mono/ui/assets/common_coin_24_ic_inchat.png");
  } else{
    return require("@mono/ui/assets/common_coins_32_ic.png");
  }
};

export const get48CoinIcon = () => {
  if (isWyak) {
    return require("@mono/ui/assets/common_coin_48_ic_wyak.png");
  } else if (isWeParty) {
    return require("@mono/ui/assets/common_coin_48_ic_weparty.png");
  } else if(isLamaLudo) {
    return require("@mono/ui/assets/common_blue_diamond_40_ic_ludo.png");
  } else if (isInChat) {
    return require("@mono/ui/assets/common_coin_48_ic_inchat.png");
  } else {
    return require("@mono/ui/assets/common_coins_40_ic.png");
  }
};

export const get88CoinIcon = () => {
  if (isWyak) {
    return require("@mono/ui/assets/common_coin_88_ic_wyak.png");
  } else if (isWeParty) {
    return require("@mono/ui/assets/common_coin_88_ic_weparty.png");
  } else if(isLamaLudo) {
    return require("@mono/ui/assets/common_blue_diamond_88_ic_ludo.png");
  } else if (isInChat) {
    return require("@mono/ui/assets/common_coin_88_ic_inchat.png");
  } else {
    return require("@mono/ui/assets/common_coins_88_ic.png");
  }
};

export function formatRechargeNum(number) {
  if (number < 1000) {
    return `${number}`;
  } else if (number < 1000000) {
    return `${(number / 1000).toFixed(3)}K`;
  } else {
    return `${(number / 1000000).toFixed(3)}M`;
  }
}

export function formatCurrency(num, separator = ",") {
  const str = String(num);
  let chars = [];
  chars.length = str.length + Math.floor((str.length - 1) / 3);
  let i = 0;
  let j = chars.length;

  let len = str.length;
  while (i < len) {
    var idx = len - i - 1;
    chars[--j] = str[idx];
    ++i;
    if (i % 3 == 0) {
      chars[--j] = separator;
    }
  }
  return chars.join("");
}
